import type React from 'react';

export const C = {
  navy: '#1D3557', gold: '#C9A227', dark: '#1a2332', surface: '#1f2b3d',
  green: '#4ECDC4', red: '#FF6B6B', orange: '#FBBF24', silver: '#A8B2C1',
  text: '#ffffff', textMuted: 'rgba(255,255,255,0.35)', textDim: 'rgba(255,255,255,0.15)',
};

export const FONT = { headline: "'Playfair Display', serif", mono: "'DM Mono', monospace", body: "'Montserrat', sans-serif" };

export const GLASS: React.CSSProperties = { background: 'rgba(255,255,255,0.03)', backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 14 };
export const GLASS_STRONG: React.CSSProperties = { ...GLASS, background: 'rgba(255,255,255,0.05)', backdropFilter: 'blur(24px)', WebkitBackdropFilter: 'blur(24px)' };

export const INPUT: React.CSSProperties = {
  width: '100%', padding: '14px 16px', background: 'rgba(255,255,255,0.04)',
  border: '1px solid rgba(255,255,255,0.08)', borderRadius: 10, color: '#fff',
  fontSize: 16, fontFamily: FONT.mono, outline: 'none', minHeight: 48,
};

export const BTN: React.CSSProperties = {
  width: '100%', padding: '16px', background: C.gold, color: C.navy,
  fontSize: 16, fontFamily: FONT.mono, fontWeight: 700, border: 'none',
  borderRadius: 10, cursor: 'pointer', minHeight: 48, textAlign: 'center',
};

export const BTN_DISABLED: React.CSSProperties = { ...BTN, background: 'rgba(255,255,255,0.06)', color: 'rgba(255,255,255,0.2)', cursor: 'not-allowed' };
